"use strict";
import { createAction } from "@reduxjs/toolkit";
export const selectPercent = createAction("burnV3/selectBurnPercent");
